import React from 'react';
import styled from 'react-emotion';
import theme from '@jetshop/ui/utils/theme';
import t from '@jetshop/intl';
import { withRouter } from 'react-router-dom';

const BackLinkWrapper = styled('div')`
  button {
    background: transparent;
    font-weight: ${theme('typo.fontWeightBold')};
    font-family: ${theme('fontFamilies.general')};
    color: ${theme('colors.product.name')};
    text-decoration: none;
    font-size: 0.875rem;
    :hover {
      color: ${theme('colors.product.nameHover')};
    }
  }
`;

const bareBackLink = ({ className = '', history }) => (
  <BackLinkWrapper className={className}>
    <button onClick={history.goBack}>{t('Go Back')}</button>
  </BackLinkWrapper>
);

const BackLink = withRouter(bareBackLink);

export default BackLink;
